import File from "@/scripts/models/file.model";
import Address from "@/scripts/models/address.model";
import {    
    VolunteeringTypes,
} from "@/scripts/models/enums/volunteeringType.enum.js";

export default class VolunteeringAttributeOffer {

    constructor() {
        this.id = -1;
        this.volunteeringId = -1;
        this.offerName = '';
        // Tags da vaga, no formato "#tag #outra". Ficavam no projeto, mas filtram a
        // vaga -- ver V1_1_204.
        this.tags = '';
        // Vaga ativa aparece nas listagens publicas. Desativar esconde sem apagar,
        // preservando as inscricoes ja feitas -- ver V1_1_205.
        this.isActive = true;
        this.function = '';
        this.preRequisites = '';
        this.isDistanceOportunityAllowed = true; 
        this.isPresentialOportunityAllowed = true;         
        this.totalOfferAmount = 1;
        // Antecedencia minima, em horas, para inscricao numa data desta vaga.
        // Aplicada somente a vagas pontuais. Default alinhado com a coluna do banco.
        this.minimumNoticeHours = 72;
        // Permite ao voluntario escolher mais de uma data ao se inscrever.
        // Aplicada somente a vagas pontuais. Default alinhado com a coluna do banco.
        this.allowMultipleDateSelection = true;
        // Antecedencia minima, em horas, para o voluntario CANCELAR a inscricao.
        // Independente do prazo de inscricao. Aplicada somente a vagas pontuais.
        this.minimumCancellationNoticeHours = 72;
        // Antecedencia, em horas, com que o e-mail de lembrete sai antes da atividade.
        // Zero desliga o lembrete. Aplicada somente a vagas pontuais.
        this.reminderNoticeHours = 48;

        // Quem a instituicao quer avisar quando alguem se inscrever nesta vaga,
        // separado por ponto e virgula. Vazio -- o normal -- nao notifica ninguem.
        this.notificationEmails = null;

        this.volunteeringType = VolunteeringTypes[0];
        
        this.file = new File();
        this.address = new Address();
        
        this.volunteeringRecurrentTypes = [];
        this.volunteeringPontualTypes = [];
    }
}